import React from "react"
import { Container, Grid, Card } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as EmploymentIcon } from "uikit/Icons/employment.svg"
import { ReactComponent as SelfEmploymentIcon } from "uikit/Icons/self-employment.svg"
import { ReactComponent as NoEmploymentIcon } from "uikit/Icons/no-employment.svg"
import { Redirect } from "react-router-dom"
import "./EmptyState.css"

const EmptyState = ({
  baseUrl,
  updateHouseholdState,
  householdState,
  household,
  isCOVID
}) => {
  if (householdState.isNotWorking) {
    // When re-rendered after updateUserState(). Shady, but working
    return <Redirect to="/organize/income+benefits" />
  }
  return (
    <Container textAlign="center" className="IncomeEmptyState">
      <Grid centered>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <h2 className="IncomeEmptyState__Header">
              How do you {isCOVID && "normally"} earn your income?
            </h2>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column
            className="IncomeEmptyState__Description"
            width={14}
            textAlign="center"
          >
            {isCOVID ? (
              <p>
                If you are currently furloughed, unemployed or have reduced
                hours, please enter what you expect to earn when things are back
                to normal.
              </p>
            ) : (
              <p>
                The next step on your journey to clarity, confidence and control
                is understanding your income and benefits so you know your
                opportunities.
              </p>
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered>
          <Grid.Column textAlign="center">
            <Card.Group itemsPerRow={3} className="IncomeEmptyState__CardGroup">
              <Card>
                <Card.Content>
                  <Link
                    data-testid="employment"
                    to={`${baseUrl}/incomes/new/employment`}
                    className="navlink"
                  >
                    <EmploymentIcon width="150px" />
                    <p>I'm an employee</p>
                  </Link>
                </Card.Content>
              </Card>
              <Card>
                <Card.Content>
                  <Link
                    data-testid="selfEmployment"
                    to={`${baseUrl}/incomes/new/selfemployment`}
                    className="navlink"
                  >
                    <SelfEmploymentIcon width="150px" />
                    <p>I'm a contractor or self-employed</p>
                  </Link>
                </Card.Content>
              </Card>
              <Card>
                <Card.Content>
                  <div
                    style={{ cursor: "pointer", color: "#00b8ee" }}
                    onClick={async () => {
                      await updateHouseholdState({
                        id: household.id,
                        isNotWorking: true
                      })
                    }}
                  >
                    <NoEmploymentIcon width="150px" />
                    <p>I don't work</p>
                  </div>
                </Card.Content>
              </Card>
            </Card.Group>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column
            textAlign="center"
            style={{ paddingBottom: "9em", paddingTop: "3em" }}
          >
            <p className="greyed-text" style={{ marginBottom: "0px" }}>
              The difference matters because it affects your taxes and how we
              plan for your future.
            </p>
            {/* <p className="greyed-text">
            <Link to="/organize/income+benefits" className="navlink">
              How do I know if I'm an employee or not?
            </Link>
          </p> */}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  )
}

export default EmptyState
